<div
  [ngClass]="inlineComponent ? 'inline-dialog-container' : 'dialog-container'"
  [style.background-color]="inlineComponent ? 'transparent' : 'white'"
  [style.visibility]="add_mx_data_feed ? 'hidden' : 'visible'"
  [style.width.px]="mx_connected_clients.length == 0 && add_mx_data_feed ? 460 : 735"
>
  @if(!inlineComponent){
  <div class="header-section mb-3">
    @if ((mx_connected_clients.length==0 && add_mx_data_feed)) {
    <p class="text-2xl font-bold w-full" style="text-align: center; top: 12px; margin: 0px; position: relative; right: 12px">
      {{ currentUser?.nick_name }}'s Linked Accounts
    </p>
    } @if (!(mx_connected_clients.length==0 && add_mx_data_feed)) {
    <p class="text-2xl font-bold w-full" style="text-align: center; top: 12px; margin: 0px; position: relative; right: 12px">
      Manage Live Data Feeds
    </p>
    }
    <button type="button" class="close add-close-button" data-dismiss="modal" (click)="closedialog()">
      <span style="font-size: 24px; font-weight: 600; color: #707070" class="material-icons icons-close-mobile">close</span>
    </button>
  </div>
  } @if (!isLoading && !add_mx_data_feed) {
  <mx-manage-templates
    [data]="mxDatList"
    [placeHolder]="textBoxPlaceHolder"
    [inlineComponent]="inlineComponent"
    (openMXPopup)="addDatafeed($event)"
    (selectionChange)="addUserAccount($event)"
    [selectedTemplate]="linkedTemplate"
    [templateConfigurationList]="templateConfigurationList"
  ></mx-manage-templates>
  } @if (mx_connected_clients.length==0 && !add_mx_data_feed && !isLoading) {
  <zero-state-mx-data 
    (addDataFeedEvent)="addDatafeed($event)" 
    (addUserAccountEvent)="addUserAccount($event)"
    [inlineComponent]="inlineComponent"
    [availableDataFeeds]="mxDatList">
  </zero-state-mx-data>
  } @if (viewAddedClient && mx_connected_clients ?.length) {
  <div style="margin: 24px 0px 24px 0px">
    <p style="margin-bottom: 16px !important" class="m-0 font-bold text-sm">Data feeds ({{ mx_connected_clients.length }})</p>
   
    @if (viewAddedClient) {
    <div class="data-feeds-grid">
      @for (subLink of mx_connected_clients; track subLink; let i = $index) {
      <div class="data-feed-card">
        <div class="flex width-100per py-3.5 justify-between items-center data-feed-item">
          <div class="pl-3 m-0 flex items-center gap-3">
            <div>
              @if (!subLink?.vaultUserForm?.profile_image_url) {
                <img class="back-avatar-grup" src="assets/images/avtar-trust.svg" />
              }
              @if (subLink?.vaultUserForm?.profile_image_url) {
                <ngx-avatars size="32" [src]="subLink?.vaultUserForm?.profile_image_url"
                  [name]="subLink?.form_name"
                  [round]="false"
                  cornerRadius="8"
                  initialsSize="2"></ngx-avatars>
              }
            </div>
            <div>
              <div class="text-sm font-normal font-sans color-[#18191C]">
                {{ subLink?.form_name?.slice(0, 20) | titlecase }}
                {{ subLink?.name?.slice(0, 20) | titlecase }}
                {{ subLink?.form_name?.length > 20 || subLink?.name?.length > 20 ? '...' : '' }}
              </div>
              <div class="text-[10px] leading-3 font-normal font-sans color-[#707070]">
                {{ subLink.type }}
              </div>
            </div>
          </div>
          <div class="flex flex-row pr-3 items-center gap-2" style="margin-top: 6px">
            @if (subLink.connection_status === 'CONNECTED') {
            <p class="m-0 flex items-center tx-center">
              <span class="material-icons" style="color: #59ab62">link</span>
            </p>
            } @if (subLink.connection_status && subLink.connection_status !== 'CONNECTED') {
            <div matTooltip="Disconnected">
              <img src="../../../../../../../assets/images/account-no-link.svg" />
            </div>
            }
            <p class="text-center px-1 w-16 font-bold text-[10px] text-[#DEA000] rounded bg-[#FFF2CD] m-0">
              In Use
            </p>
            <p class="m-0 flex items-center cursor-pointer tx-center">
              <span class="material-icons" [matMenuTriggerFor]="menuItem" style="color: #25508e">more_vert</span>
            </p>
          </div>
          <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
            <button mat-menu-item class="popup-menu-item remove-link text-[#EB5757]" (click)="removelinkedForm(subLink)">
              <span style="font-size: 16px" class="material-icons">link_off</span>
              <span style="position: relative; top: -3px; left: 8px"> Unlink </span>
            </button>
          </mat-menu>
        </div>
      </div>
      }
    </div>
    }
    <p style="margin-bottom: 16px !important; margin-top: 24px !important" class="m-0 font-bold text-sm">Available Data feeds ({{ mxDatList.length }})</p>
    <div class="data-feeds-grid">
      @for (item of mxDatList; track item; let i = $index) {
      <div class="data-feed-card">
        <div class="flex width-100per py-3.5 justify-between items-center data-feed-item cursor-pointer" (click)="addUserAccount(item)">
          <div class="pl-3 m-0 flex items-center gap-3">
            <div>
              @if (!item?.profile_image_url) {
                <img class="back-avatar-grup" src="assets/images/avtar-trust.svg" />
              }
              @if (item?.profile_image_url) {
                <ngx-avatars size="32" [src]="item?.profile_image_url"
                  [name]="item?.form_name"
                  [round]="false"
                  cornerRadius="8"
                  initialsSize="2"></ngx-avatars>
              }
            </div>
            <div>
              <div class="text-sm font-normal font-sans color-[#18191C]">
                {{ item?.form_name }}
              </div>
              <div class="text-[10px] leading-3 font-normal font-sans color-[#707070]">
                {{ item?.type }}
              </div>
            </div>
          </div>
          <div class="flex flex-row pr-3 items-center gap-2" style="margin-top: 6px">
            @if (!item?.vaultUserForm?.id) {
            <p class="text-center px-1 w-16 font-bold text-[10px] text-[#1AA140] rounded bg-[#DAF4F2] m-0">
              Available
            </p>
            } @if (item?.vaultUserForm?.id) {
            <p class="text-center px-1 w-16 font-bold text-[10px] text-[#DEA000] rounded bg-[#FFF2CD] m-0">
              In Use
            </p>
            }
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  } @if (isLoading) {
  <div class="mt-6" style="height: 320px">
    <div class="loader-container flex flex-col w-full">
      @for (item of loadingItems; track item) {
      <div style="width: 100%">
        <div class="flex loader-body" id="{{ item.id }}" style="width: 100%">
          <div class="ph-item width-100per loader-body-item" style="padding: 18px 12px 9px 12px">
            <div class="ph-col-12" style="padding: 0px !important">
              <div class="ph-row">
                <div class="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  } 
  <!-- @if (!inlineComponent && !hide_checkbox_section) {
  <div class="action" style="text-align: start; border-top: 1px solid #d3dce8; margin: 12px -18px 0px -18px">
    <form [ngClass]="inlineComponent ? 'text-start' : 'text-center'" [formGroup]="myForm">
      <mat-slide-toggle formControlName="name" style="margin: 18px 18px 0px 18px" class="font-normal text-[#515765] text-sm margin-zero" (change)="onToggleChange($event)">
        Mark this attribute complete
      </mat-slide-toggle>
    </form>
  </div>
  } -->
</div>
